import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "../..";
import StorageItems from "../../../storage";
import { generateMessageReturn } from "../../../utils/messageFuncs";

const auth = new StorageItems().get("authToken");

class ApiFiscal extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  token;
  basePath = "fiscal";
  constructor(data?: any) {
    super();
    this.token = auth?.authToken;

    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.token ? `Bearer ${this.token}` : "",
      },
    };

    if (data) {
      this.data = data;
      this.config.data = data;
    }
  }

  listImpostos = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/list/impostos`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Listar Impostos",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };
}

export default ApiFiscal;
